import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import * as landlordQueries from '~settings/queries';
import endpoints from '~settings/endpoints';
import { setWithdrawalMethods } from '~actions/withdrawal';
import { fetch } from '~helpers/graphql';
import WithDrawalList from '~pages/withdrawal/list';
import WithDrawalEdit from '~pages/withdrawal/edit';

const mapDispatchToProps = dispatch => ({
  setWithdrawalMethods: list => {
    dispatch(setWithdrawalMethods(list));
  },
});
@connect(null, mapDispatchToProps)
export default class WithDrawal extends React.Component {
  constructor() {
    super();

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    fetch({
      url: endpoints.getWithdrawalMethods.url(),
      query: landlordQueries.getWithdrawalMethods(),
    }).then(res => {
      this.props.setWithdrawalMethods(
        (res.listWithdrawMethods &&
          res.listWithdrawMethods.edges &&
          res.listWithdrawMethods.edges.map(item => item.node)) ||
          [],
      );
      this.setState({
        loading: false,
      });
    });
  }

  render() {
    return (
      <div className="withdrawal">
        <Choose>
          <When condition={this.state.loading}>
            <div className="withdrawal__loading" />
          </When>
          <Otherwise>
            <Switch>
              <Route path="/withdrawal/list" component={WithDrawalList} />
              <Route path="/withdrawal/:id/edit" component={WithDrawalEdit} />
              <Route path="/withdrawal/create" component={WithDrawalEdit} />
              <Route
                path="/withdrawal/callback"
                render={() => {
                  const { code, error, state } = queryString.parse(this.props.location.search);
                  const callbackParams = JSON.stringify({
                    code: code || '',
                    error: error || '',
                    state: state || '',
                  });
                  localStorage.setItem('STRIPE_CALLBACK_PARAMS', callbackParams);
                  window.close();
                  return false;
                }}
              />
              <Redirect to="/withdrawal/list" />
            </Switch>
          </Otherwise>
        </Choose>
      </div>
    );
  }
}

WithDrawal.propTypes = {
  setWithdrawalMethods: PropTypes.func,
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

WithDrawal.defaultProps = {
  t: () => {},
  setWithdrawalMethods: () => {},
};
